<template>
    <div class="nrca_box">
        <el-row >
          <el-col :span="4" class="nrca_border">
            <div class="grid-content nrca_text">
              <div class="nrca_max">NRCA</div>
              <div class="nrca_en">全国读书创作活动</div>
            </div>
          </el-col>
          <el-col :span="20" >
            <el-row>
              <el-col v-for="(v,k,i) in activity_nrca" :key="i"  :span="4" class="nrca_border">
                <div class="grid-content nrca_status">
                  <img :src="require('@/assets/images/' +  k + '.png')" />
                  <div >{{v}}</div>
                  <div >{{arr[i]}}</div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row >
      </div>

</template>

<script>
    export default {
      name: 'IndexNrca',
      data () {
        return {
          arr:['参赛机构数','社团数','参赛人数','作品总数','点赞总数','浏览总数']
       };
      },
      props: ['activity_nrca'],
      methods: {

      }
    }
</script>
<style scoped>
    /* nrca部分 */
  .nrca_box{
    width: 1200px;
    margin: 20px auto;
    background: white !important;
    border-radius: 5px !important;

  }
  .nrca_box >.el-row{
    width: 1200px;
    height: 150px;

  }
  .nrca_box >.el-row >:last-child > :last-child{
    border: none !important;
  }
  .grid-content {
    height:142px;
  }
  .nrca_box  .nrca_border{
    height: 150px;
    padding: 4px !important;
    box-sizing: border-box !important;
  }


  .nrca_text{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #3370ff;
    border-radius: 4px;

  }
  .nrca_status{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #EAEAEA;
    box-sizing: border-box !important;
  }
  .el-row .nrca_border:last-child > .nrca_status{
    border-right: none;
  }


  .nrca_status img{
    width: 37px;
    height: 37px;
    margin-bottom: 5px;

  }
  .nrca_status div{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
  .nrca_max{
    font-size: 37px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-style: italic;
    color: #F3F3F3;
  }
  .nrca_en{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-style: italic;
    color: #F3F3F3;
  }
</style>



// WEBPACK FOOTER //
// src/index/components/Nrca.vue